import { t as translate } from "../preferences";
import {
  AlertTriangle,
  ArrowLeft,
  Construction,
  LoaderCircle,
  RefreshCw,
  WifiOff,
} from "lucide-react";
import { Link } from "react-router-dom";
import type { AppRoute } from "../routes";

export function BootScreen() {
  return (
    <main
      className="m-app-viewport m-app-safe-frame m-flex m-items-center m-justify-center m-bg-background m-p-6"
      aria-busy="true"
      aria-label={translate("Ilova yuklanmoqda")}
    >
      <div className="m-text-center">
        <LoaderCircle className="m-mx-auto m-size-8 m-animate-spin m-text-primary" />
        <p className="m-mt-4 m-text-sm m-font-medium m-text-muted">{translate("Ilova tayyorlanmoqda…")}</p>
      </div>
    </main>
  );
}

export function ErrorScreen({
  offline,
  message,
  onRetry,
}: {
  offline: boolean;
  message: string;
  onRetry: () => void;
}) {
  const Icon = offline ? WifiOff : AlertTriangle;
  return (
    <main className="m-app-viewport m-app-safe-frame m-flex m-items-center m-justify-center m-bg-background m-p-5">
      <section className="m-w-full m-max-w-sm m-rounded-app m-border m-border-border m-bg-surface m-p-6 m-text-center m-shadow-card">
        <span className="m-mx-auto m-flex m-size-14 m-items-center m-justify-center m-rounded-2xl m-bg-elevated m-text-primary">
          <Icon className="m-size-7" aria-hidden="true" />
        </span>
        <h1 className="m-mt-5 m-text-xl m-font-bold m-text-foreground">
          {offline ? translate("Aloqa yo‘q") : translate("Xatolik yuz berdi")}
        </h1>
        <p className="m-mt-2 m-break-words m-text-sm m-leading-6 m-text-muted">{message}</p>
        <button className="m-primary-button m-mt-6" type="button" onClick={onRetry}>
          <RefreshCw className="m-size-5" aria-hidden="true" />
          {translate("Qayta urinish")}</button>
      </section>
    </main>
  );
}

export function PlaceholderScreen({ route }: { route: AppRoute }) {
  const Icon = route.icon;
  return (
    <section className="m-mx-auto m-flex m-w-full m-max-w-sm m-flex-col m-items-center m-py-10 m-text-center">
      <span className="m-flex m-size-16 m-items-center m-justify-center m-rounded-2xl m-bg-elevated m-text-primary">
        <Icon className="m-size-8" aria-hidden="true" />
      </span>
      <p className="m-mt-5 m-text-xs m-font-bold m-uppercase m-tracking-[0.18em] m-text-primary">
        Usta ilovasi poydevori
      </p>
      <h1 className="m-mt-2 m-text-2xl m-font-bold m-tracking-tight m-text-foreground">
        {route.title}
      </h1>
      <p className="m-mt-3 m-max-w-[280px] m-text-sm m-leading-6 m-text-muted">
        {route.description}
      </p>
      <div className="m-mt-7 m-flex m-items-center m-gap-2 m-rounded-full m-border m-border-border m-bg-surface m-px-4 m-py-2 m-text-xs m-font-semibold m-text-muted">
        <Construction className="m-size-4" aria-hidden="true" />
        Hozircha namuna holati
      </div>
    </section>
  );
}

export function NotFoundScreen() {
  return (
    <section className="m-mx-auto m-flex m-w-full m-max-w-sm m-flex-col m-items-center m-py-10 m-text-center">
      <span className="m-flex m-size-16 m-items-center m-justify-center m-rounded-2xl m-bg-elevated m-text-primary">
        <ArrowLeft className="m-size-8" aria-hidden="true" />
      </span>
      <p className="m-mt-5 m-text-xs m-font-bold m-uppercase m-tracking-[0.18em] m-text-primary">
        404
      </p>
      <h1 className="m-mt-2 m-text-2xl m-font-bold m-text-foreground">{translate("Sahifa topilmadi")}</h1>
      <p className="m-mt-3 m-text-sm m-leading-6 m-text-muted">
        {translate("Havola noto‘g‘ri yoki bu bo‘lim hali mavjud emas.")}</p>
      <Link className="m-primary-button m-mt-6" to="/mechanic/">
        {translate("Bosh sahifaga qaytish")}</Link>
    </section>
  );
}
